import { useNavigate } from 'react-router-dom';

import { Stack, Typography, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import EmailIcon from '@mui/icons-material/Email';
import { Link } from 'react-router-dom';

const ContactUsSection = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  return (
    <Box marginLeft={theme.spacing(2)}>
      <Button href= 'https://www.datalyscenter.org/contact-us/' sx={{ display: { xs: 'none', sm: 'block' }, textTransform: 'none' }}>
      <Stack direction="row" alignItems="center" spacing={1}>
          <EmailIcon sx={{ color: 'primary.main' }} />
          <Typography variant = 'h3' sx={{ color: 'primary.main' }}><b>Contact Us</b></Typography>
        </Stack>
      </Button>
    </Box>
  );
};

export default ContactUsSection;
